module.exports = __webpack_public_path__ + "static/media/aom-primary-logo-1.64b0d62d.png";